import * as Sentry from '@sentry/react';
import { getEnvVar } from './util';

export const initRendererSentry = () => {
  const dsn = getEnvVar('SENTRY_DSN');
  const env = getEnvVar('NODE_ENV');
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV ?? 'production',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    enabled: env === 'production',
    // supabase-js (GoTrueClient) serializes auth-refresh calls via the Web
    // Locks API. When a prior lock request is stuck (typically because the
    // device went offline mid-refresh), a later request uses the 'steal'
    // option to break it, which throws this AbortError in the original
    // stuck call. It's self-healing and not actionable — see
    // supabase/supabase-js#1401, #1594, #1645.
    ignoreErrors: ["Lock broken by another request with the 'steal' option."],
  });
};
